import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IVentricularAssistDeviceState } from '../store/ventricularAssistDevice.types'
import { getVentricularAssistDeviceSelector } from '../selectors'
import { VentricularAssistDeviceConstants } from '../store/ventricularAssistDevice.constants'

export function* setProcedureComplications() {
  try {
    const procedureState: IProcedureState = yield select(getProcedureStateSelector)
    const ventricularAssistDeviceState: IVentricularAssistDeviceState = yield select(getVentricularAssistDeviceSelector)
    const { inputRows } = procedureState
    const { procedureComplications } = ventricularAssistDeviceState
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === VentricularAssistDeviceConstants.SET_PROCEDURE_COMPLICATIONS) {
          //@ts-ignore
          input.props.savedValues = procedureComplications
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setProcedureComplicationsSaga() error: ${e}`))
  }
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest(
    [VentricularAssistDeviceConstants.SET_PROCEDURE_COMPLICATIONS],
    performWithMutexHOG,
    setProcedureComplications
  )
}
